import { Col, Form, Row, Select, Spin, Table, Tabs } from 'antd'
import React, { Component } from 'react'
import { PmsAPI } from '../../../controller/PmsAPI';
import moment from 'moment';
import ResponsiveECharts from '../../components/ResponsiveECharts';

const columns = [
    {
        title: '房型',
        dataIndex: 'room_cod',
        key: 'room_cod',
        sorter: (a, b) => a.room_cod?.localeCompare(b.room_cod),
    },
    {
        title: '總計',
        dataIndex: 'tot',
        key: 'tot',
        align: 'right',
        sorter: (a, b) => a.tot - b.tot,
    },
    {
        title: '已銷售',
        dataIndex: 'occupied',
        key: 'occupied',
        align: 'right',
        sorter: (a, b) => a.occupied - b.occupied,
    },
    {
        title: '空房',
        dataIndex: 'free',
        key: 'free',
        align: 'right',
        sorter: (a, b) => a.free - b.free,
    },
    {
        title: '空房率',
        dataIndex: 'free',
        key: 'free',
        align: 'right',
        render: (value, record) => {
            let result = value / record.tot * 100;
            let color = '';
            let level = Math.ceil((result / (100 / 3)));
            switch (level) {
                case 3:
                    color = 'red'; break;
                default:
                case 2:
                    color = 'black'; break;
                case 1:
                    color = 'green'; break;

            }
            return <span style={{ color: color }}>{result.toFixed(2)}</span>
        },
        sorter: (a, b) => {
            const aPercent = a.tot ? (a.free / a.tot * 100) : 0;
            const bPercent = b.tot ? (b.free / b.tot * 100) : 0;
            return aPercent - bPercent;
        },
    },
    {
        title: '估計單價',
        dataIndex: 'unitprice',
        key: 'unitprice',
        align: 'right',
        render: (value) => Number(value).toLocaleString(),
        sorter: (a, b) => a.unitprice - b.unitprice,
    },
    {
        title: '估計銷售總值',
        dataIndex: 'sale_value',
        key: 'sale_value',
        align: 'right',
        render: (value, record) => Number(value).toLocaleString(),
        sorter: (a, b) => a.sale_value - b.sale_value,
    },
    {
        title: '佔比',
        dataIndex: 'sale_value',
        align: 'right',
        render: (value, record) => Number(value / record.total_sale * 100).toFixed(2),
        sorter: (a, b) => {
            const aRatio = a.total_sale ? (a.sale_value / a.total_sale) : 0;
            const bRatio = b.total_sale ? (b.sale_value / b.total_sale) : 0;
            return aRatio - bRatio;
        },
    }
];

const columnsByNo = [
    {
        title: '房號',
        dataIndex: 'room_nos',
        key: 'room_nos',
        sorter: (a, b) => String(a.room_nos).localeCompare(String(b.room_nos))
    },
    {
        title: '房型',
        dataIndex: 'room_cod',
        key: 'room_cod',
        sorter: (a, b) => String(a.room_cod).localeCompare(String(b.room_cod))
    },
    {
        title: '總計',
        dataIndex: 'tot',
        key: 'tot',
        align: 'right',
        sorter: (a, b) => a.tot - b.tot,
    },
    {
        title: '已銷售',
        dataIndex: 'occupied',
        key: 'occupied',
        align: 'right',
        sorter: (a, b) => a.occupied - b.occupied
    },
    {
        title: '空房',
        dataIndex: 'free',
        key: 'free',
        align: 'right',
        sorter: (a, b) => a.free - b.free

    },
    {
        title: '最後使用',
        dataIndex: 'last_use',
        key: 'last_use',
        render: (value) => moment(value).format("YYYY-MM-DD"),
        sorter: (a, b) => new Date(a.last_use) - new Date(b.last_use)
    },
    {
        title: '連續未使用天數',
        dataIndex: 'last_use',
        key: 'last_use',
        align: 'right',
        render: (value) => moment().diff(value, 'days'),
        sorter: (a, b) => moment().diff(a.last_use, 'days') - moment().diff(b.last_use, 'days'),
    },
];
export class RoomTypePage extends Component {
    state = {
        loading: false,
        detailLoading: false,
        periodType: 'year',
        roomUsageStatChartOption: null,
        roomUsagePieChartOption: null,
        roomUsageBarChartOption: null,
        details: [],
        detailsByNo: [],
        selectDetail: null,
    }
    componentDidMount() {
        this.refresh();
    }
    refresh = () => {
        this.updateRoomUsageStatChartOption();
    }
    handleSelectPeriodType = (value) => {
        console.log("handleSelectPeriodType", value);
        this.setState({ periodType: value }, () => this.refresh());
    }
    updateRoomUsageStatChartOption = async () => {
        this.setState({ loading: true });
        const response = await PmsAPI.room.stat(this.state.periodType).finally(() => {
            this.setState({ loading: false });
        })
        const result = response.data;
        const items = result.items;
        console.log(result);

        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                }
            },
            legend: {},
            dataset: {
                source: items
            },
            xAxis: {
                type: 'time',
                axisLabel: {
                    formatter: (value, index) => {
                        let today = false;
                        if (moment().format("YYYY-MM-DD") === moment(value).format("YYYY-MM-DD")) {
                            today = true;
                        }
                        let style = 'bold';
                        let result = null;
                        if (today) style = 'today';
                        if (this.state.periodType === 'day')
                            result = `{yy}\n{${style}|{MM}}\n{${style}|{dd}}\n{${style}|{ee}}`;
                        else if (this.state.periodType === 'month')
                            result = `{yyyy}\n{${style}|{MM}}`;
                        else
                            result = `{yyyy}`;
                        return result;
                    },
                    rich: {
                        bold: {
                            fontWeight: 700
                        },
                        today: {
                            color: '#aa5555',
                            fontWeight: 700
                        }
                    }
                }
            },
            yAxis: {
                type: 'value',
                name: '間數',
                min: 0,
            },
            series: [
                {
                    name: '已銷售',
                    type: 'bar',
                    stack: 'total',
                    encode: { x: 'dat', y: 'occupied' },
                },
                {
                    name: '空房',
                    type: 'bar',
                    stack: 'total',
                    encode: { x: 'dat', y: 'free' },
                },
            ]
        };
        this.setState({ roomUsageStatChartOption: option });
    }
    updateRoomUsageBarChartOption = () => {
        const items = this.state.details.reverse();
        const option = {
            title: {
                text: '各房型銷售間數'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                }
            },
            legend: {},
            grid: {
                containLabel: true
            },
            dataset: {
                source: items
            },
            xAxis: {
                type: 'value',
            },
            yAxis: {
                type: 'category',
                name: '房型'
            },
            series: [
                {
                    name: '已銷售',
                    type: 'bar',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    encode: { x: 'occupied', y: 'room_cod' }
                },
            ]
        };
        this.setState({ roomUsageBarChartOption: option });
    }
    updateRoomUsagePieChartOption = () => {
        const items = this.state.details;
        const option = {
            title: {
                text: '各房型銷售總值佔比'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {d}%'
            },
            legend: {
                type: 'scroll',
                orient: 'vertical',
                right: 10,
                top: 20,
                bottom: 20,
            },
            dataset: {
                source: items,
            },
            series: [
                {
                    name: '銷售比例',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },

                    encode: { value: 'sale_value', itemName: 'room_cod' }
                }
            ]
        };
        this.setState({ roomUsagePieChartOption: option });
    }
    handleClickChartEvent = (e) => {
        const date = e.data.dat;
        this.fetchDetail(date);
        console.log("click", e, date)
    }
    getUnitPriceOfRoom = (roomCod) => {
        let unitPrice = 0;
        switch (roomCod.trim()) {
            case 'CEO':
                unitPrice = 15000;
                break;
            case 'CON':
                unitPrice = 5000;
                break;
            case 'FMB':
                unitPrice = 6800;
                break;
            case 'NFM':
                unitPrice = 6500;
                break;
            case 'FM':
                unitPrice = 6500;
                break;
            case 'S4':
                unitPrice = 4800;
                break;
            case 'DTB':
                unitPrice = 4800;
                break;
            case 'DTL':
            case 'DT':
                unitPrice = 4500;
                break;
            case 'ACC':
                unitPrice = 3900;
                break;
            case 'STB':
                unitPrice = 3500;
                break;
            default:
            case 'STL':
                unitPrice = 3200;
                break;
        }
        return unitPrice;
    }
    fetchDetail = async (date) => {
        this.setState({ detailLoading: true, detailDate: date });
        const p1 = PmsAPI.room.index(this.state.periodType, date).then((response) => {
            const result = response.data;
            const items = result.items.map((item) => ({
                ...item,
                unitprice: this.getUnitPriceOfRoom(item.room_cod),
                sale_value: this.getUnitPriceOfRoom(item.room_cod) * item.occupied,
                unsale_value: this.getUnitPriceOfRoom(item.room_cod) * item.free,
            })).map((item, idx, arr) => ({
                ...item,
                total_sale: arr.reduce((pv, cv, idx) => pv + cv.sale_value, 0)
            })).sort((a, b) => b.sale_value - a.sale_value);
            this.setState({ details: items }, () => {
                this.updateRoomUsagePieChartOption();
                this.updateRoomUsageBarChartOption();
            });
        })
        const p2 = PmsAPI.room.statByNo(this.state.periodType, date).then((response) => {
            const result = response.data;
            this.setState({ detailsByNo: result });
        });
        Promise.all([p1, p2]).finally(() => {
            this.setState({ detailLoading: false });
        });
    }
    render() {
        return (
            <Spin spinning={this.state.loading}>
                <h1>房型統計</h1>
                <Form>
                    <Row gutter={5} justify="end">
                        <Col xs={24} sm={24} lg={4}>
                            <Form.Item label="週期">
                                <Select value={this.state.periodType} onChange={this.handleSelectPeriodType}>
                                    <Select.Option key="year">年</Select.Option>
                                    <Select.Option key="month">月</Select.Option>
                                    <Select.Option key="day">日</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <ResponsiveECharts option={this.state.roomUsageStatChartOption} onEvents={{
                    'click': this.handleClickChartEvent
                }} />
                <Row style={{ marginBottom: 10 }}>
                    <Col span={18}>查詢日期: {this.state.detailDate ? this.state.detailDate : '無'}</Col>
                </Row>
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane key="1" tab="摘要">
                        <Row gutter={[10, 20]}>
                            <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
                                <ul>
                                    <li>空房率偏低應考慮增加房間數</li>
                                    <li>空房率偏高應考慮修正房型價值、價格定位以符合客群</li>
                                    <li>實際估計單價應參考各房型的平均售價</li>
                                </ul>
                                <Table
                                    columns={columns}
                                    dataSource={this.state.details}
                                    loading={this.state.detailLoading} pagination={false}
                                    scroll={{ x: 'max-content' }}
                                    size="small"
                                />
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                                <ResponsiveECharts option={this.state.roomUsagePieChartOption} />
                                <ResponsiveECharts style={{ height: 600 }} option={this.state.roomUsageBarChartOption} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane key="2" tab="依房號">
                        <Table columns={columnsByNo} dataSource={this.state.detailsByNo} loading={this.state.detailLoading} size="small" scroll={{ x: 'max-content' }} />
                    </Tabs.TabPane>
                </Tabs>
            </Spin>
        )
    }
}

export default RoomTypePage